import React, { Component } from 'react';
import $ from 'jquery';
import { Link ,browserHistory} from 'react-router';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class ChangeVerifyOtp extends Component {
	constructor(props,context){
		super(props);
		this.state={
			mobile: localStorage.getItem('mobile_number'),
			invalid_otp: '',
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.gotoLogin= this.gotoLogin.bind(this);
		this.resendOtp = this.resendOtp.bind(this);
	}
	componentDidMount(){
		this.refs.otp.focus();
	}
	resendOtp(){
		
		var data1= {from :'mobile_web',mobile: this.state.mobile};
		var data2= JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'resendOtp',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
			},
			error: function(err){
				
			}
		});
	}
	handleSubmit(event){
		event.preventDefault();
		var data1= {from: 'mobile_web',uid : localStorage.getItem('user_id'),token: localStorage.getItem('token'),mobile: localStorage.getItem('mobile_number'),otp: this.refs.otp.value};
		var data2 = JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'verifyChangeMobileOtp',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
				if(data.status === "success"){
					browserHistory.push('/profile');
				}
				if(data.status==='fail'){
					this.setState({
						err:true,
						invalid_otp: 'Invalid Otp',
					});
				}
			}.bind(this),
			error: function(err){
			}
		})
	}
	gotoLogin(event){
		event.preventDefault();
		browserHistory.push('/login');
	}
	
	render(){
		document.title="Verify OTP | AquaDeals";
	return(
	<div className="mob_deals mob_changenumber_otp_page">
		<section className="tot_pag">
			<div className="page_hdr">
				<div className="container">
					<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Verify OTP</h5>
					<a href="/" className="home_newicon"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home"/></a>
				</div>
			</div>
			<section className="pag_cntnt">
				<div className="container">
					<div className="signup_form">
						<div className="">
					    	<div className="enquire_form signup_blk proced_blk" style={{marginLeft:'20px',marginRight:'20px'}}>
					    		<div className="newlogin_logo"><img src={baseAssets+'icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
					        	<form className="mtrl_elmnts" onSubmit={this.handleSubmit}>
						        	<div className="col-md-12" style={{marginLeft:'20px',marginRight:'20px'}}>
					        			<div className="col-md-12">
					        				<div className="group">      
					         					<input type="text" ref="otp" maxLength={6} required />
					          					<span className="highlight"></span>
												<span className="bar"></span>
												{this.state.err ? this.state.invalid_otp : ''}
												<label>Enter OTP</label>
					        				</div>
					        			</div>
					        			<button onSubmit={this.handleSubmit.bind(this)} action="submit" className="btn mob_social_verifybtn">Verify <i className="glyphicon glyphicon-menu-right"></i></button>
					        		</div>
					        		<div className="forgot_pasword verify_blk">
					                    <h5>Didn't receive the OTP?</h5>
					                    <div className="tap" >
					                   		<a style={{cursor:'pointer'}} onClick={this.resendOtp}>Tap here to resend</a>
					                    </div>
					                </div>  
					   			</form>
					    	</div>
					    	<div className="clr">&nbsp;</div>
					    </div>
			    	</div>
				</div>
			</section>
			<div className="clr">&nbsp;</div>
		</section>	
	</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Auth/ChangeVerifyOtp.js
 **/